export default class FestivalHeroScrollIndicator {
    constructor($el) {
        this.$el = $el;
        this.handleClick = this.handleClick.bind(this);

        this.$el.addEventListener('click', this.handleClick);
    }

    handleClick() {
        const $header = document.querySelector('.header');
        const scrollPosition = window.scrollY + this.$el.getBoundingClientRect().top - $header.offsetHeight + 80;

        window.scrollTo({
            behavior: 'smooth',
            top: scrollPosition,
        });
    }
}
